import { Link } from 'react-router-dom';

export type Crumb = {
  label: string;
  path?: string;
};

export default function Breadcrumb({ items, tone = 'light' }: { items: Crumb[]; tone?: 'light' | 'dark' }) {
  const base = tone === 'dark' ? 'text-background-400' : 'text-foreground-500';
  const link = tone === 'dark' ? 'hover:text-accent-400' : 'hover:text-primary-600';
  const current = tone === 'dark' ? 'text-background-100' : 'text-foreground-800';
  const sep = tone === 'dark' ? 'text-background-600' : 'text-foreground-300';

  return (
    <nav aria-label="面包屑导航" className={`text-xs ${base}`}>
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, idx) => (
          <li key={`${item.label}-${idx}`} className="flex items-center gap-2">
            {item.path ? (
              <Link to={item.path} className={`${link} transition-colors cursor-pointer`}>
                {item.label}
              </Link>
            ) : (
              <span className={current}>{item.label}</span>
            )}
            {idx < items.length - 1 && <i className={`ri-arrow-right-s-line ${sep}`}></i>}
          </li>
        ))}
      </ol>
    </nav>
  );
}